<template>
  <v-container style="top: 24px;">
    <v-row justify="center">
      <h1>Enter your {{ companyTitle }} agency code here:</h1>
    </v-row>
    <v-row justify="center">
      <v-col
        sm="6"
        md="4"
      >
        <v-form @submit.prevent="searchTracking(trackingNumber, selectedDate)">
          <v-text-field
            id="order-search"
            v-model.trim.number="trackingNumber"
            label="Agency code"
            placeholder="123456789"
            outlined
            solo
            append-icon="fa-arrow-right"
            @click:append="searchTracking(trackingNumber, selectedDate)"
          />
        </v-form>
      </v-col>
      <v-col
        sm="6"
        md="4"
      >
        <v-menu
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="selectedDate"
              label="Order Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="selectedDate"
            class="mb-8"
            :min="minDate"
            :max="maxDate"
            @change="handleDateChange"
          />
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import router from "@/router";
import { defineComponent } from "vue";

type Data = {
  trackingNumber: string,
  selectedDate: string,
  minDate: string,
  maxDate: string
}

export default defineComponent({
  props: {
    companyTitle: {
      type: String,
      required: true,
    },
  },
  data: (): Data => {
    return {
      trackingNumber: "",
      selectedDate: "",
      minDate: "",
      maxDate: ""
    };
  },
  mounted: function () {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    };

    // Use en-CA locale string for YYYY-mm-dd support with v-date-picker
    this.selectedDate = new Date().toLocaleDateString('en-CA', options);
    this.minDate = (() => {
      const today = new Date();
        today.setDate(today.getDate() - 7);
        return today.toLocaleDateString('en-CA', options);
    })();
    this.maxDate = new Date().toLocaleDateString('en-CA', options);
  },
  methods: {
    searchTracking: (trackingNumber: string, selectedDate: string) => {
      router.push({ path:`/alco/${trackingNumber}`, query: { selectedDate: selectedDate } });
    },
    handleDateChange(date: string) {
      this.selectedDate = date;
      return;
    }
  }
});
</script>
